import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, FileTextIcon } from 'lucide-react';
import { Button } from './Button';
import { BlobBackground } from './BlobBackground';
import { BotanicalLeaf } from './BotanicalLeaf';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-133">
      {/* Background Elements */}
      <div className="absolute top-[-10%] left-[-5%] w-96 h-96 opacity-40 z-0" data-id="element-134">
        <BlobBackground color="var(--color-mint)" data-id="element-135" />
      </div>
      <div className="absolute bottom-[-10%] right-[-5%] w-[30rem] h-[30rem] opacity-30 z-0" data-id="element-136">
        <BlobBackground color="var(--color-sage)" data-id="element-137" />
      </div>
      <div className="absolute top-20 right-20 text-sage opacity-20 z-0 w-32 h-64" data-id="element-138">
        <BotanicalLeaf data-id="element-139" />
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-140">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-141">
          {/* Text Content */}
          <motion.div className="flex-1 max-w-2xl" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-142">
            <div className="inline-block px-4 py-1.5 rounded-full bg-mint/30 text-forest text-sm font-medium tracking-wider mb-6" data-id="element-143">
              NUEVO EBOOK DIGITAL
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif leading-tight mb-4 tracking-wide" data-id="element-144">
              Adiós <br data-id="element-145" />
              <span className="italic text-sage" data-id="element-146">Inflamación</span>
            </h1>

            <h2 className="text-2xl md:text-3xl font-serif text-forest/80 mb-6" data-id="element-147">
              Protocolo de 48 Horas
            </h2>

            <p className="text-lg md:text-xl text-charcoal/80 mb-10 leading-relaxed" data-id="element-148">
              Reduce visiblemente el volumen digestivo y alivia la rigidez
              articular en tus primeras 48 horas. Descubre por qué tu cuerpo
              está "en llamas" y cómo apagarlo.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mb-12" data-id="element-149">
              <Button href="#comprar" data-id="element-150">Descargar Ahora</Button>
              <div className="flex flex-col gap-2 text-sm text-charcoal/70" data-id="element-151">
                <div className="flex items-center gap-2" data-id="element-152">
                  <ShieldCheckIcon size={16} className="text-sage" data-id="element-153" />
                  <span data-id="element-154">Garantía de 30 días</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-155">
                  <DownloadIcon size={16} className="text-sage" data-id="element-156" />
                  <span data-id="element-157">Acceso Inmediato</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-158">
                  <FileTextIcon size={16} className="text-sage" data-id="element-159" />
                  <span data-id="element-160">Formato PDF (Móvil y Tablet)</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div className="flex-1 w-full max-w-xl lg:max-w-none" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-161">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-sage/20 border border-white/50" data-id="element-162">
              <img src="https://cdn.magicpatterns.com/uploads/t9XaArPCZXBBxbtpZp4wkD/heylloyd-image-1779714887679.png" alt="Adiós Inflamación Ebook en Tablet y Móvil" className="w-full h-auto object-cover" data-id="element-163" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}